<div *ngIf="display">
    <header class="header header-6 theme-container" fxHide fxShow.gt-md>
        <div class="header-top ">
            <div fxLayout="row" fxFlex fxLayoutAlign="space-around center" style="padding: 1% 5%;">

                <div fxLayout="row" fxLayoutAlign="start center"fxLayoutGap="10px">
                    <!-- <button (click)="searchLocation()" [style.color]="data.headerIconColour" class="responsive-toggle"
                        mat-icon-button>
                        <div fxLayout="row" fxLayoutAlign="start center" style="align-items: center;">
                            <img src="assets/icons/download (7).png" alt="marker"
                                style="width: 24px; height: 24px; margin-right: 8px;" />
                        </div>
                    </button>
                    <p class="truncate-text" style="color: gray;font-size: 12px;text-align: center; margin-top: 0px;">
                        <span style="color: rgb(84, 84, 84);font-size: 15px; margin-right: 5px;font-weight: bold;">
                            {{location_title}}
                        </span> {{location_address}}</p> -->
                     <img src="assets/icons/Map Pin.png" alt="marker"
                                style="width: 17px;height: 22px;margin-right: 8px;" /> 
                      <h2 style="font-size: 15px;font-weight: bold;color: rgb(84, 84, 84);;">{{data.city}}</h2> 
                      <span style="font-size: 13px;color: rgb(84, 84, 84);">{{data.streetAddress}}</span>            
                </div>

                <div class="header-right">

                    <div fxLayout="row" fxLayoutGap="10px">
                        <div (click)="gotoCall()" *ngIf="data.showContactNumber==1" fxLayoutAlign="center center"
                            style="cursor: pointer;color: gray;">
                            <h3> Hotline : <span style="font-size: 13px;border-bottom: 1px solid gray;">
                                    {{data.storePhoneNumber}}
                                </span></h3>
                        </div>
                        <div style="border-right:1px gray solid ;height: 22px;">

                        </div>

                        <div (click)="composeEmail(data.smtpUsername)" class="header-left"
                            style="cursor: pointer;color: gray;">
                            <!-- <mat-icon  class="icon-css">mail</mat-icon>{{data.smtpUsername}} -->
                            <h3> Mail : <span style="font-size: 13px; border-bottom: 1px solid gray;">
                                    {{data.smtpUsername}}
                                </span></h3>
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="borderbottom">

        </div>

        <div>
            <div fxLayout="row" fxLayoutAlign="space-between center" style="padding: 0% 6%;width: 100%;">

                <div fxFlex="10">
                    <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>
                </div>

                <div fxFlex="70" style="padding: 20px;" fxLayoutAlign="start center">
                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
                        <calsoft-search5 (callhideSearchBar)="hideSearch($event)" showSearchBar
                            [searchbarborderRadius]="'5px'"></calsoft-search5>
                    </div>

                </div>

                <div fxFlex="20" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                    <div>
                        <div fxLayoutAlign="center center" *ngIf="!userLoggedIn" (click)="SignIn('login')"
                            style="position: relative;cursor: pointer;">
                            <div fxLayoutAlign="center center" *ngIf="data.disableLoginHeader==0">
                                <div>
                                    <!-- <mat-icon class="icon-css1" style="color: black;">person_outline</mat-icon> -->
                                    <img src="assets/icons/Profile 1.png" alt="marker"
                                        style="width: 25px; height: 25px;" />
                                </div>
                            </div>
                        </div>
                        <div *ngIf="data.disableLoginHeader==0">
                            <calsoft-HeaderUserProfileDropdown [data]="data"
                                *ngIf="userLoggedIn"></calsoft-HeaderUserProfileDropdown>
                        </div>
                    </div>
                    <div style="border-right:1px gray solid ;height: 25px;">

                    </div>
                    <div fxLayoutAlign="center center">
                        <div fxLayoutAlign="center center" *ngIf="url != '/cart'">
                            <div *ngIf="disableCartIconInHeader==0" fxLayout="row" fxLayoutGap="10px">
                                <div (click)="cart()" fxLayoutAlign="center center"
                                    style="position: relative;cursor: pointer;">
                                    <img src="assets/icons/Bag 1.png" alt="marker"
                                        style="width: 25px; height: 25px;" />
                                         <!-- <img src="../../../../../assets/icons/cart-black.svg" alt="Cart Icon" width="40" height="40"> -->
                                    <span *ngIf="cartServices.cartCount > 0" class="badge" style="
                                            position: absolute;
                                            top: -9px;
                                            right: -8px;
                                            background-color: green;
                                            color: white;
                                            border-radius: 50%;
                                            padding: 2px 7px;
                                            font-size: 12px;
                                          ">
                                        {{ cartServices.cartCount }}
                                    </span>
                                </div>

                                <!-- Cart Info -->
                                <div fxLayout="column"  fxLayoutAlign="start start"  style="display: flex; flex-direction: column; align-items: flex-start;width: max-content;line-height: 1;">
                                    <p style="font-size: 13px; color: gray;">Shopping cart</p>
                                    <p *ngIf="grandTotal > 0" style="color: black; font-weight: bold;">
                                        ₹{{ grandTotal }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="url!='/'" style="margin-bottom: 10px;" class="borderbottom">

        </div>


    </header>
</div>
<div *ngIf="!display">

    <div *ngIf="mobileHeaderType==1">
        <calsoft-mobile-header [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header>
    </div>

    <div *ngIf="mobileHeaderType==0">
        <calsoft-mobile-header-new [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header-new>
    </div>

    <div *ngIf="mobileHeaderType==2">
        <calsoft-mobile-header3 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header3>
    </div>

    <div *ngIf="mobileHeaderType==3">
        <calsoft-mobile-header4 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header4>
    </div>

    <div *ngIf="mobileHeaderType==4">
        <calsoft-mobile-header5 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header5>
    </div>

    <div *ngIf="mobileHeaderType==5">
        <calsoft-mobile-header6 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header6>
    </div>
    <div *ngIf="mobileHeaderType==6">
        <calsoft-mobile-header7 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header7>
    </div>
    <div *ngIf="mobileHeaderType==7">

        <calsoft-mobile-header8 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header8>
    </div>
    <div *ngIf="mobileHeaderType==8">
        <calsoft-mobile-header9 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header9>
    </div>

    <div *ngIf="mobileHeaderType==9">
        <calsoft-mobile-header10 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header10>
    </div>
</div>